import { callCoreApi } from "../../services/coreApi";
import { crmApiFetch } from "../../services/crmApi";

export const TASK_STATUSES = [
	"can_wait",
	"not_started",
	"working_on_it",
	"testing",
	"done",
];

export const TASK_PRIORITIES = ["low", "medium", "high", "urgent"];

function compactPayload(payload) {
	return Object.fromEntries(
		Object.entries(payload).filter(([, value]) => value !== undefined)
	);
}

export async function createProject(projectData) {
	const payload = compactPayload({
		title: projectData.title,
		description: projectData.description,
		status: projectData.status,
	});

	const data = await callCoreApi("/api/pm/projects", {
		method: "POST",
		body: payload,
	});

	return data.project;
}

export async function listProjects() {
	const data = await callCoreApi("/api/pm/projects", { method: "GET" });
	return data.projects || [];
}

export async function getProjectById(projectId) {
	const data = await callCoreApi(`/api/pm/projects/${projectId}`, { method: "GET" });
	return data.project;
}

export async function updateProject(projectId, updates) {
	const payload = compactPayload({
		title: updates.title,
		description: updates.description,
		status: updates.status,
	});

	const data = await callCoreApi(`/api/pm/projects/${projectId}`, {
		method: "PATCH",
		body: payload,
	});

	return data.project;
}

export async function deleteProject(projectId) {
	return callCoreApi(`/api/pm/projects/${projectId}`, { method: "DELETE" });
}

export async function addProjectMember(projectId, memberData) {
	const payload = compactPayload({
		user_id: memberData.userId,
		role: memberData.role,
	});

	const data = await callCoreApi(`/api/pm/projects/${projectId}/members`, {
		method: "POST",
		body: payload,
	});

	return data.member;
}

export async function removeProjectMember(projectId, userId) {
	return callCoreApi(`/api/pm/projects/${projectId}/members/${userId}`, {
		method: "DELETE",
	});
}

export async function listProjectTasks(projectId) {
	const data = await callCoreApi(`/api/pm/projects/${projectId}/tasks`, { method: "GET" });
	return data.tasks || [];
}

export async function getTaskById(taskId) {
	const data = await callCoreApi(`/api/pm/tasks/${taskId}`, { method: "GET" });
	return data.task;
}

export async function createTask(projectId, taskData) {
	const payload = compactPayload({
		title: taskData.title,
		description: taskData.description,
		assigned_user_id: taskData.assignedUserId,
		status: taskData.status,
		priority: taskData.priority,
		due_date: taskData.dueDate,
		sort_order: taskData.sortOrder,
	});

	const data = await callCoreApi(`/api/pm/projects/${projectId}/tasks`, {
		method: "POST",
		body: payload,
	});

	return data.task;
}

export async function updateTask(taskId, updates) {
	const payload = compactPayload({
		title: updates.title,
		description: updates.description,
		assigned_user_id:
			updates.assignedUserId === null ? 0 : updates.assignedUserId,
		status: updates.status,
		priority: updates.priority,
		due_date: updates.dueDate,
		sort_order: updates.sortOrder,
	});

	const data = await callCoreApi(`/api/pm/tasks/${taskId}`, {
		method: "PATCH",
		body: payload,
	});

	return data.task;
}

export async function deleteTask(taskId) {
	return callCoreApi(`/api/pm/tasks/${taskId}`, { method: "DELETE" });
}

export async function listTaskComments(taskId) {
	const data = await callCoreApi(`/api/pm/tasks/${taskId}/comments`, {
		method: "GET",
	});
	return data.comments || [];
}

export async function createTaskComment(taskId, content) {
	const data = await callCoreApi(`/api/pm/tasks/${taskId}/comments`, {
		method: "POST",
		body: { content },
	});

	return data.comment;
}

export async function deleteTaskComment(commentId) {
	return callCoreApi(`/api/pm/comments/${commentId}`, { method: "DELETE" });
}

export async function getTeamMembers() {
	const response = await crmApiFetch(`/api/contacts/team-members`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch team members");
	}

	return payload.team_members || [];
}
